import React from "react";
import { FaHeartbeat, FaStethoscope, FaExclamationTriangle, FaInfoCircle } from "react-icons/fa";
import PropTypes from "prop-types";

// Icon mapping
const ICONS = {
  success: <FaHeartbeat className="w-4 h-4 text-green-500" />,
  warning: <FaExclamationTriangle className="w-4 h-4 text-yellow-500" />,
  info: <FaInfoCircle className="w-4 h-4 text-blue-500" />,
  alert: <FaStethoscope className="w-4 h-4 text-red-500" />,
};

export default function AlertsPanel({ alerts }) {
  return (
    <div className="w-full h-full overflow-y-auto space-y-2 p-2">
      <h2 className="classHeading text-gray-800 mb-2">Healthcare Alerts</h2>
      {alerts.map((alert) => (
        <div
          key={alert.id}
          className="flex items-start gap-1 p-2 bg-white rounded-lg shadow border-l-4 transition-all duration-150 hover:shadow-md"
          style={{
            borderColor:
              alert.type === "success"
                ? "#22c55e"
                : alert.type === "warning"
                ? "#facc15"
                : alert.type === "info"
                ? "#3b82f6"
                : "#ef4444",
          }}
        >
          <div>{ICONS[alert.type]}</div>
          <div className="flex-1">
            <p className="font-medium text-gray-800 text-sm">{alert.title}</p>
            {alert.message && <p className="text-xs text-gray-600 truncate">{alert.message}</p>}
            {alert.timeStamp && (
              <div className="text-[10px] text-gray-400 mt-0.5">
                {alert.timeStamp}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

AlertsPanel.propTypes = {
  alerts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.oneOf(["success", "warning", "info", "alert"]).isRequired,
      title: PropTypes.string.isRequired,
      message: PropTypes.string,
      timestamp: PropTypes.string, // ISO string
    })
  ),
};

AlertsPanel.defaultProps = {
  alerts: [],
};
